import "./ApiKeyPage.scss";

import React, { useEffect, useState } from "react";

import { LoadingOverlay } from "../../../../components/LoadingOverlay/LoadingOverlay";
import { useOrganizationContext } from "../../../../contexts/organizations/organizationsContext";
import { useApplications } from "../../../../hooks/reactQueryHooks/useApplications";
import { useKeys } from "../../../../hooks/reactQueryHooks/useKeys";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import convertArrayToObject from "../../../../utils/convertArrayToObject";
import ApiKeyTable from "../ApiKeyTable/ApiKeyTable";

interface IProps {
  setKeysAmount: (amount: number) => void;
}

const ApiKeyPage: React.FC<IProps> = ({ setKeysAmount }) => {
  const pageSize = 10;
  const { queryValue: searchQuery } = useQueryParams({
    queryStr: "s",
  });

  const { queryValue: pageIndex } = useQueryParams({
    queryStr: "p",
  });
  const { currentOrganization } = useOrganizationContext();

  const organizationId: string = currentOrganization?.id || "";

  const result = useKeys({
    organizationId,
    pageIndex: pageIndex ? Number(pageIndex) : undefined,
    pageSize,
    search: searchQuery || "",
  });
  const {
    data: { items: data, filteredCount = 0 } = {},
    isLoading,
    isFetching,
  } = result;

  useEffect(() => {
    setKeysAmount(filteredCount);
  }, [filteredCount, setKeysAmount]);

  const { data: applications } = useApplications(organizationId);
  const [dataWithAppName, setDataWithAppName] = useState<any[]>([]);

  useEffect(() => {
    if (data) {
      const res = applications?.length
        ? convertArrayToObject(applications)
        : {};
      const dataWithAppName = data.map(item => {
        return {
          ...item,
          appName: res[item.applicationId]?.name,
        };
      });
      setDataWithAppName(dataWithAppName);
    }
  }, [data, applications]);

  return (
    <>
      <div className="card ">
        <div className="app-container-inner-wrapper card-body d-flex flex-column">
          <div className="api-key-capion">
            The API keys can be used to read and write data to CogCache.{" "}
          </div>
          <div className="api-key-capion api-key-bold pb-5">
            Please do not share these keys and make sure they are stored
            somewhere secure.
          </div>
          <ApiKeyTable
            items={dataWithAppName || []}
            isLoading={isLoading || isFetching}
            totalCount={filteredCount}
            pageSize={pageSize}
          />
        </div>
      </div>
      {(isLoading || isFetching) && <LoadingOverlay />}
    </>
  );
};

export default ApiKeyPage;
